import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/contexts/CartContext";

export default function Header() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);

  const navLink = ({ isActive }) =>
    `relative px-1 py-1 text-sm tracking-wide transition-colors ${
      isActive ? "text-[#D97757]" : "text-[#2C211B] hover:text-[#D97757]"
    }`;

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#EAE3D9]"
    >
      <div className="container-x flex items-center justify-between py-4">
        <Link
          to="/"
          data-testid="brand-link"
          className="font-serif text-2xl lg:text-3xl tracking-tight leading-none"
        >
          Teddys
          <span className="font-script text-[#D97757] ml-2 text-2xl">tiny friends</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={navLink} data-testid="nav-home">Home</NavLink>
          <NavLink to="/shop" className={navLink} data-testid="nav-shop">Shop</NavLink>
          <NavLink to="/personalise" className={navLink} data-testid="nav-custom">Personalise</NavLink>
          <NavLink to="/about" className={navLink} data-testid="nav-about">Our Story</NavLink>
          <NavLink to="/contact" className={navLink} data-testid="nav-contact">Contact</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/cart"
            data-testid="header-cart-link"
            className="relative p-2 rounded-full hover:bg-[#F4EFE6] transition-colors"
            aria-label="Cart"
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-1 -right-1 bg-[#D97757] text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded-full hover:bg-[#F4EFE6]"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#EAE3D9] bg-white">
          <div className="container-x py-4 flex flex-col gap-3">
            {[
              ["/", "Home", "mnav-home"],
              ["/shop", "Shop", "mnav-shop"],
              ["/personalise", "Personalise", "mnav-custom"],
              ["/about", "Our Story", "mnav-about"],
              ["/contact", "Contact", "mnav-contact"],
            ].map(([to, label, tid]) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                data-testid={tid}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2 ${isActive ? "text-[#D97757]" : "text-[#2C211B]"}`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
